import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=395889fa&"
import script from "./HeaderBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports